import C from 'actionTypes'

export const openNav = () => ({
  type: C.OPEN_NAV
})

export const closeNav = () => ({
  type: C.CLOSE_NAV
})



// WEBPACK FOOTER //
// ./src/actions/client/mobileNav.js